








































































import { Vue, Component } from 'vue-property-decorator';

import esignLogo from '@/assets/logos/logo_esign_orange.svg';
import kagaLogo from '@/assets/logos/logo_kaga.svg';
import formLogo from '@/assets/logos/logo_logoform.png';
import surveyLogo from '@/assets/logos/logo_survey.png';
import showtime24Logo from '@/assets/logos/logo_showtime24.jpg';

@Component({
  name: 'ServiceSection',
  components: {
  },
})
/**
 * @vuese
 * @group Page/ServiceSection
 * ServiceSection component
 */
export default class ServiceSection extends Vue {
  // [data]
  esignLogo: string = esignLogo;
  kagaLogo: string = kagaLogo;
  formLogo: string = formLogo;
  surveyLogo: string = surveyLogo;
  showtime24Logo: string = showtime24Logo;
}
